// @ts-nocheck
import { apiClient } from '../base-classes/apiBaseClass';
import { makeAutoObservable } from "mobx";
import notificationState from './notification-state';

interface email_config {
    username: string;
    password: string;
    host: string;
    port: string;
    email_from?: string;
}

interface paddle_config {
    paddle_url: string;
    paddle_api_key: string;
    product_id: string;
}

interface paddle_client_config {
    client_key: string;
    environment: string;
}


interface pdf_config {
    watermark: string,
    daily_limit: number,
    maximum_pages_allowed: any,
}
export interface IConfigValues {
    email_config: email_config;
    paddle_config: paddle_config;
    paddle_client_config: paddle_client_config;
    pdf_config: pdf_config;
    recaptcha_config: {
        site_key: string;
        secret_key: string;
    };
}

const initialValues: IConfigValues = {
    email_config: {
        username: '',
        password: '',
        host: '',
        port: '',
        email_from: ''
    },
    paddle_config: {
        paddle_url: '',
        paddle_api_key: '',
        product_id: ''
    },
    paddle_client_config: {
        client_key: '',
        environment: ''
    },
    pdf_config: {
        watermark: "",
        daily_limit: 3,
        maximum_pages_allowed: 0,
    },
    recaptcha_config: {
        site_key: '',
        secret_key: ''
    }
};

class SettingsState {
    configSettings: IConfigValues = initialValues;
    clientSettings: any;
    recaptchaSiteKey: string | null = null;

    constructor() {
        makeAutoObservable(this);
        this.fetchClientSettings();
    }

    get paddleEnviroment() {
        return {
            environment: this.clientSettings?.paddleClientConfigData?.value?.environment,
            token: this.clientSettings?.paddleClientConfigData?.value?.client_key,
        }
    }

    private async fetchClientSettings() {
        const response = await apiClient.get("client-settings");
        if (response && response.data && response.status) {
            this.clientSettings = response.data;
            this.recaptchaSiteKey = response.data.recaptchaSiteKey || null;
        }
    }

    async getClientSettings() {
        if (!this.clientSettings) {
            await this.fetchClientSettings();
        }
        return this.clientSettings;
    }

    async getRecaptchaSiteKey() {
        if (!this.recaptchaSiteKey) {
            await this.fetchClientSettings();
        }
        return this.recaptchaSiteKey;
    }

    async getSettingsAdmin() {
        try {
            const response = await apiClient.get("admin/settings");
            if (response.status && response.data) {
                const transformedData: IConfigValues = {
                    email_config: {
                        username: response.data?.emailConfigData?.value?.username ?? '',
                        password: response.data?.emailConfigData?.value?.password ?? '',
                        host: response.data?.emailConfigData?.value?.host ?? '',
                        port: response.data?.emailConfigData?.value?.port ?? '',
                        email_from: response.data?.emailConfigData?.value?.email_from ?? '',
                    },
                    paddle_config: {
                        paddle_url: response.data?.paddleConfigData?.value?.paddle_url ?? '',
                        paddle_api_key: response.data?.paddleConfigData?.value?.paddle_api_key ?? '',
                        product_id: response.data?.paddleConfigData?.value?.product_id ?? '',
                    },
                    paddle_client_config: {
                        client_key: response.data?.paddleClientConfigData?.value?.client_key ?? '',
                        environment: response.data?.paddleClientConfigData?.value?.environment ?? 'production',
                    },
                    pdf_config: {
                        watermark: response.data?.pdfData?.value?.watermark ?? '',
                        daily_limit: response.data?.pdfData?.value?.daily_limit ?? 0,
                        maximum_pages_allowed: response.data?.pdfData?.value?.maximum_pages_allowed ?? 0,
                    },
                    recaptcha_config: {
                        site_key: response.data?.recaptchaConfigData?.value?.site_key ?? '',
                        secret_key: response.data?.recaptchaConfigData?.value?.secret_key ?? ''
                    }
                };

                this.configSettings = transformedData;
            }
        } catch (e) {
            this.handleError(e);
        }
    }

    async save(values: IConfigValues & { recaptcha_config: { site_key: string, secret_key: string } }): Promise<void> {
        try {
            const response = await apiClient.post("admin/settings-store", values);
            if (response.status) {
                notificationState.addToasterSuccess(response.message || 'Settings Saved Successfully.');
                await this.getSettingsAdmin();
            } else {
                this.handleError(response.message || "Something went wrong...");
            }
        } catch (e) {
            this.handleError(e);
        }
    }

    handleError(error: any) {
        const e = typeof error === "string" ? error : (error.message || 'Something went wrong, try again...');
        notificationState.addToasterError(e);
    }
}

const settingsState = new SettingsState();
export default settingsState;
